exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".VaBZyqgObt_Yviuulmpvo{margin:-10px -10px 0}.VaBZyqgObt_Yviuulmpvo.unlocked .react-draggable{cursor:move}.VaBZyqgObt_Yviuulmpvo.locked .react-resizable-handle{display:none}.VaBZyqgObt_Yviuulmpvo .react-grid-placeholder{background:#16ace3}", ""]);

// exports
exports.locals = {
	"reactGridLayout": "VaBZyqgObt_Yviuulmpvo"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/common/ReactGridContainer.css
// module id = 528
// module chunks = 57